import { useState, useEffect } from 'react'
// import LogRocket from 'logrocket'
import * as Sentry from '@sentry/nextjs'
import { useWalletStore, WalletStore } from 'store/index'
import shallow from 'zustand/shallow'
import DebugModal from 'components/DebugModal'
import { useStore, Store } from 'store/state/store'
import { useRouter } from 'next/router'

const walletStoreSelector = (state: WalletStore) => ({
  activeAccount: state.activeAccount
})

const storeSelector = (state: Store) => ({
  isDebugEnabled: state.isDebugEnabled,
  setIsDebugEnabled: state.setIsDebugEnabled
})

export default function useLogger({ shouldPrompt = false }: { shouldPrompt?: boolean }) {
  const { activeAccount } = useWalletStore(walletStoreSelector, shallow)
  const { isDebugEnabled, setIsDebugEnabled } = useStore(storeSelector, shallow)
  const router = useRouter()

  const [isDialogOpen, setIsDialogOpen] = useState(shouldPrompt && !isDebugEnabled)

  const handleOpenCloseDialog = (isOpen: boolean) => {
    setIsDialogOpen(isOpen)
  }

  const handleClickAccept = () => {
    setIsDebugEnabled(true)
    setIsDialogOpen(false)
  }

  const handleClickDecline = () => {
    setIsDebugEnabled(false)
    setIsDialogOpen(false)
    router.replace(router.pathname, undefined, { shallow: true })
  }

  const DebugDialog = () =>
    DebugModal({
      isOpen: isDialogOpen,
      setIsOpen: handleOpenCloseDialog,
      onClickAccept: handleClickAccept,
      onClickDecline: handleClickDecline
    })

  // useEffect(() => {
  //   if (!isDebugEnabled) {
  //     return
  //   }

  //   if (process.env.NEXT_PUBLIC_LOG_ROCKET_APP_ID && typeof window !== 'undefined') {
  //     LogRocket.init(process.env.NEXT_PUBLIC_LOG_ROCKET_APP_ID)

  //     LogRocket.getSessionURL((sessionURL) => {
  //       console.info('LogRocket URL:', sessionURL)
  //       Sentry.configureScope(function (scope) {
  //         scope.setTag('LogRocket-URL', sessionURL)
  //       })
  //     })
  //   }
  // }, [isDebugEnabled])

  useEffect(() => {
    const account = activeAccount?.address
    const provider = activeAccount?.providerId

    // if (process.env.NEXT_PUBLIC_LOG_ROCKET_APP_ID && account && provider && isDebugEnabled) {
    //   LogRocket.identify(account)
    // }

    Sentry.configureScope((scope) => {
      scope.setTag('account', account)
      Sentry.setUser({ account, provider })
    })
  }, [activeAccount?.address, activeAccount?.providerId, isDebugEnabled])

  return {
    DebugDialog
  }
}
